import styled from "styled-components";
import { Container } from "../../globalStyles";
import { Link } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";
import { dark } from "../../globalData";

export const Nav = styled.nav`
  background: ${({ hide }) => (hide ? "transparent" : dark)};
  margin-top: -80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
`;

export const NavbarContainer = styled(Container)`
  display: flex;
  justify-content: start;
  height: 80px;
`;

export const NavLogo = styled(Link)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
  z-index: 50;
`;

export const NavbarUserName = styled.h4`
  display: flex;
  text-align: center;
  font-weight: 300;
  font: 16px;
  color: white;
  align-items: center;
  justify-content: center;
`;

export const NavbarSignOut = styled.div`
  font-size: 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  align-self: center;
  text-align: center;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  justify-self: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  @media screen and (max-width: 540px) {
    font-size: 14px;
  }

  @media screen and (max-width: 414px) {
    font-size: 12px;
  }
`;

export const NavbarSignoutButton = styled.h4`
  display: flex;
  text-align: center;
  font-weight: 300;
  font: 16px;
  color: white;
  align-items: center;
  justify-content: center;
`;

export const NavIcon = styled.img`
  margin-right: 1rem;
  width: auto;
  height: 50px;

  @media screen and (max-width: 540px) {
    height: 40px;
  }

  @media screen and (max-width: 414px) {
    height: 30px;
    margin-left: -20px;
  }
`;
export const MobileIcon = styled.div`
  display: none;
  z-index: 50;
  align-items: center;
  margin-right: 25px;

  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 70%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const HeaderBasketCount = styled.span`
  text-decoration: none;
  color: white;
  padding: 4px 5px 5px 5px;
  font-size: 20px;
  position: absolute;

  align-items: center;
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  width: 100%;

  @media screen and (max-width: 960px) {
    flex-direction: column;
    width: 100%;
    height: 100vh;
    color: white;
    position: fixed;
    padding-top: 30%;
    top: 0;
    left: 0;
    opacity: ${({ show }) => (show ? 1 : 0)};
    visibility: ${({ show }) => (show ? "visible" : "hidden")};
    transform: translateY(${({ show }) => (show ? "0" : "-10px")});
    transition: opacity 0.5s ease;
    background-color: black;
  }

  > li:first-child {
    margin-left: auto;
  }
`;

export const NavItem = styled.li`
  height: 80px;
  cursor: pointer;

  @media screen and (max-width: 960px) {
    width: 100%;

    &:hover {
      border: none;
    }
  }
`;

export const NavLinks = styled(LinkScroll)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  &.active {
    text-shadow: 0 0 20px #aa0000, 0 0 15px #aa0000, 0 0 10px #aa0000;

    @media screen and (min-width: 960px) {
      border-bottom: 2px solid red;
    }
  }
  &:hover {
    color: #c8c9d8;
    transition: all 0.3s ease;
  }

  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;

    &:hover {
      color: #4b59f7;
      transition: all 0.3s ease;
    }
  }
`;
